export default function initPrisaLibrary() {
  const src = 'https://ak-ads-ns.prisasd.com/slot/elpais_juegos/slot.js';
  if (document.querySelector(`script[src='${src}']`)) {
    return;
  }
  const container = document.head || document.body;
  const script = Object.assign(document.createElement('script'), { src, defer: '' });
  container.appendChild(script);
}
